import script from "./CmmPopupAnswersDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CmmPopupAnswersDialog.vue?vue&type=script&setup=true&lang=js"

import "./CmmPopupAnswersDialog.vue?vue&type=style&index=0&id=0c62bc68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c62bc68"]])

export default __exports__